import HeroCarousel from "@/pages/home/components/HeroCarousel";
import BrandIntro from "@/pages/home/components/BrandIntro";
import ServiceEntry from "@/pages/home/components/ServiceEntry";
import FeaturedWorks from "@/pages/home/components/FeaturedWorks";
import LatestNews from "@/pages/home/components/LatestNews";
import CtaBand from "@/components/feature/CtaBand";

export default function Home() {
  return (
    <div>
      <HeroCarousel />
      <BrandIntro />
      <ServiceEntry />
      <FeaturedWorks />
      <LatestNews />
      <CtaBand />
    </div>
  );
}